'use client';

import { c as _c } from "react/compiler-runtime";
import { type Session } from '@shared/all/domains/sessions';
import useUser from '@shared/utils/hooks/useUser';
import { useEffect, useState } from 'react';
import { spaceConfig } from '../../utils/getSpaceConfig';
import { client } from '../../utils/trpc';
import TwoFAInfo from '../auth/TwoFAInfo';
import Button from '../common/Button';
import SessionItem from './SessionItem';
import SignInMethods from './SignInMethods';
const Security = () => {
  const $ = _c(18);
  const {
    currentUser,
    setUser
  } = useUser();
  const [sessions, setSessions] = useState(null);
  const [infoOpen, setInfoOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== currentUser.twoFaEnabled) {
    t0 = () => {
      if (!currentUser.twoFaEnabled) {
        return;
      }
      let ignore = false;
      const fetchSessions = async () => {
        const [error, result] = await client.sessions.get.query();
        if (ignore || error) {
          return;
        }
        setSessions(result.sessions.filter(_temp));
      };
      fetchSessions();
      return () => {
        ignore = true;
      };
    };
    t1 = [currentUser.twoFaEnabled];
    $[0] = currentUser.twoFaEnabled;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== currentUser || $[4] !== setUser) {
    t2 = id => {
      setSessions(previous => {
        if (!previous) {
          return previous;
        }
        const updated = previous.filter(session => session.id !== id);
        if (updated.length === 0) {
          setUser({
            ...currentUser,
            twoFaEnabled: false
          });
        }
        return updated;
      });
    };
    $[3] = currentUser;
    $[4] = setUser;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const removeSessionFromState = t2;
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><h2 className="text-2xl font-semibold">Security</h2><p className="text-sm text-textSecondary/60">Manage how you sign in to your account. You always keep at least one method.</p></div>;
    t4 = <SignInMethods />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currentUser.hasPassword || $[9] !== currentUser.twoFaEnabled || $[10] !== removeSessionFromState || $[11] !== sessions) {
    t5 = currentUser.hasPassword && <section className="space-y-3"><h3 className="font-emphasis">Two-factor authentication</h3>{!currentUser.twoFaEnabled && <><p className="text-sm text-textSecondary">Require a phone approval when signing in with your password on a new device. Turn it on from the {spaceConfig.space.slug} mobile app.</p><Button variant="SECONDARY" text="How to enable 2FA" classNames="w-full" onClick={() => setInfoOpen(true)} /></>}{currentUser.twoFaEnabled && <><p className="text-sm text-textSecondary">2FA is on. Each listed device can approve a sign-in. Removing all of them turns 2FA off.</p><div className="space-y-2">{sessions?.map((session_0, index) => <SessionItem key={session_0.id} session={session_0} removeSession={() => removeSessionFromState(session_0.id)} isLast={index === sessions.length - 1} />)}</div></>}</section>;
    $[8] = currentUser.hasPassword;
    $[9] = currentUser.twoFaEnabled;
    $[10] = removeSessionFromState;
    $[11] = sessions;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== infoOpen) {
    t6 = infoOpen && <TwoFAInfo closeHandler={() => setInfoOpen(false)} enable2FAHandler={() => setInfoOpen(false)} />;
    $[13] = infoOpen;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="max-w-sm space-y-8 p-6">{t3}{t4}{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default Security;
function _temp(s) {
  return s.device;
}